import { render, staticRenderFns } from "./ChangeDetectionBox.vue?vue&type=template&id=f8e71a3a"
import script from "./ChangeDetectionBox.vue?vue&type=script&lang=ts"
export * from "./ChangeDetectionBox.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports